import React from 'react'
import styled from 'styled-components'
import Link from 'gatsby-link'
import Img from 'gatsby-image'
import presets from "../utils/presets"
import {rhythm} from "../utils/typography"

const BlogTile = styled.div`
  height: 120px;
  width: 120px;
  position: relative;
  flex-grow: 1;
  overflow:hidden;
  flex-basis:50%;

  a {
    width:100%;
    height:100%;
    position:absolute;
    top:0;
    left:0;
    }

  div:first-child {
    width:100%;
    height:100%;
    position:absolute;
  }

  @media screen and ${presets.phablet.por}{
    height: 160px;
  }

  @media screen and ${presets.tablet.por}{
    height: 240px;
    flex-basis:30%;
  }

  @media screen and ${presets.desktop.lan}{
    height: 360px;
  }

  @media screen and ${presets.fourk.lan}{
    height: 420px;
  }
`

export default BlogTile



// WEBPACK FOOTER //
// ./src/com/BlogTile.js